import { ExpressionType } from '../../IExpression.ts';
import { type IAsyncExpression } from '../async/IAsyncExpression.ts';
import { type IFunctionExpression } from '../function/IFunctionExpression.ts';
import { type IReferenceExpression } from '../reference/IReferenceExpression.ts';
import { type IValueExpression } from '../value/IValueExpression.ts';

/**
 * Tipo che rappresenta un'assegnazione al livello più basso
 * possibile, ovvero sul singolo campo.
 * Se viene modificato, allineare anche `AllAssignableExpressionTypes`.
 */
export type IAssignableExpression =
  | IValueExpression
  | IReferenceExpression
  | IAsyncExpression
  | IFunctionExpression;

export type AssignableExpressionType = IAssignableExpression['type'];

/**
 * Elenco di tutti i tipi di espressioni che possono essere assegnate.
 * L'order è importante perché è quello in cui vengono visualizzate le
 * espressioni nell'editor.
 */
export const AllAssignableExpressionTypes = [
  ExpressionType.Value,
  ExpressionType.Reference,
  ExpressionType.Function,
  ExpressionType.Async,
] as const;
